module.exports = __webpack_public_path__ + "static/media/logo_new_device.7bb77a3e.png";